import { Controller } from "stimulus"
import * as autoformatters from "../lib/autoformatters.js";

export default class extends Controller {

  connect() {
    this.element.addEventListener('input', this.autoformat);
  }

  disconnect() {
    this.element.removeEventListener('input', this.autoformat);
  }

  get formatType() {
    return this.element.dataset?.autoformat;
  }

  autoformat = (evt) => {
    if (evt.target.value) {
      const returnVal = autoformatters[this.formatType](evt.target.value);
      if (returnVal.value) this.element.value = returnVal.value;
    }
  }
}